<template>
  <div
    class="flex items-center pt-2.5 pr-2.5 pb-2.5 pl-3 rounded-[4px] border border-accent-200 bg-white gap-2 self-center h-10 shadow-xs"
    :class="[`!${customClass}`, variant]"
  >
    <ClientOnly>
      <font-awesome-icon
        class="text-accent-400 w-5 h-5"
        :icon="['fas', 'magnifying-glass']"
      />
    </ClientOnly>
    <input
      v-model="inputText"
      class="outline-none text-accent-400 font-sans text-sm not-italic font-normal tracking-[-0.084px]"
      :class="[`${customInputClass}`]"
      :placeholder="$t(placeholder)"
    />
    <ClientOnly v-if="showClearBtn">
      <font-awesome-icon
        v-if="inputText.trim() !== ''"
        class="text-accent-950 cursor-pointer"
        :icon="['far', 'xmark']"
        @click="() => (inputText = '')"
      />
    </ClientOnly>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";
const props = defineProps({
  searchText: {
    type: String,
    required: true,
  },
  placeholder: {
    type: String,
    required: false,
    default: "navbar.monitor.find",
  },
  variant: {
    type: String,
    default: "standard",
  },
  customClass: {
    type: String,
    default: "",
  },
  customInputClass: {
    type: String,
    default: "",
  },
  showClearBtn: {
    type: Boolean,
    default: true,
  },
});

const emit = defineEmits(["input"]);

const inputText = computed({
  get() {
    return props.searchText;
  },
  set(newVal) {
    emit("input", newVal);
  },
});
</script>

<style scoped>
.standard {
  @apply border border-accent-300;
}

.no-border {
  @apply border-none;
}
</style>
